module.exports = __webpack_public_path__ + "img/03.c16e6ded.jpg";